<template>
  <footer>
    Episode screens and information provided by
    <a href="http://thetvdb.com/">The TVDB</a>.  Please help them by
    contibuting.
  </footer>
</template>

<script>
export default {
  name: 'app-footer'
};
</script>

<style scoped>
footer {
  padding: 1em;
  font-size: .75em;
}
</style>



// WEBPACK FOOTER //
// AppFooter.vue?f79bb740